<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
   <div>
       <Breadcrumbs main="Accessory" title="Details" />

      <div class="container-fluid">
         <div class="row">
            <div class="col-sm-12">

               <div class="card">
                  <div class="card-body">
                     <div class="row">
                        <div class="col-md-10 d-flex">
                           <h5>Ad Details</h5>
                        </div>
                        <div class="col-md-2">
                           <h6>Status: 
                              <span class="text-danger" v-if="accessory.status==0">Blocked</span>
                              <span class="text-success" v-if="accessory.status==1">Active</span>
                              <span class="text-info" v-if="accessory.status==2">Requested</span>
                           </h6>
                        </div>
                        
                     </div><br>
                     <div class="details">  
                        <div class="row">
                           <!-- <div class="col md-6 lg-2 "> 

                              <img v-if="accessory.user_image" :src="$image_url + accessory.user_image" alt="Image not found" class="img-fluid avatar-60 rounded-small">
                              <img v-else :src="$image_url + accessory.default_image" alt="Image not found" class="img-fluid avatar-120 rounded-small">
                           </div>  -->

                           <div class="col md-6 lg-4">
                              <h6>Ad. ID:</h6>
                              <p>{{accessory.ad_id}}</p>
                           </div> 

                           <div class="col md-6 lg-3 ">
                              <h6>Title:</h6>
                              <p>{{accessory.title}}</p>
                           </div> 

                           <div class="col md-6 lg-3 ">
                              <h6>Price:</h6>
                              <p>Rs. {{accessory.price}}</p>   
                           </div>

                           <div class="col md-6 lg-3 ">
                              <h6>Category:</h6>
                              <p>{{accessory.cat_name}}</p>   
                           </div>

                           <div class="col md-6 lg-3 ">
                              <h6>Description:</h6>
                              <p>Rs. {{accessory.description}}</p>   
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               
               <div class="card">
                  <div class="card-body">
                     <div class="row">
                        <h5>Location</h5>
                     </div><br>
                     
                     <div class="details">  
                        <div class="row">                          
                           <div class="col md-12 lg-12">
                              <p>{{accessory.location}}</p>                              
                           </div> 
                        </div>

                        <div  class="col md-12 lg-12">
                           <div class="gmap_canvas">
                              <iframe class="gmap_iframe" width="100%" height="300px" frameborder="0" scrolling="no" marginheight="0"
                                 marginwidth="0" :src="getMapUrl()"></iframe >
                           </div>
                        </div>
                     </div>

                  </div>
               </div>

               <div class="card">
                  <div class="card-body">
                     <div class="row">
                        <h6 class="card-title">User Details</h6>
                     </div >
                     
                     <div class="details mt-3">  
                        <div class="row">
                           <div class="col-md-6 lg-4">                              
                              <img :src="$image_url + accessory.user_image" alt="Image" style="width:130px">
                           </div > 

                           <div class="col md-6 lg-4">
                              <h6>Name:</h6>
                              <p>{{accessory.user_name}}</p>
                              <h6>Contact</h6>
                              <p class="mb-0">{{accessory.country_code}} {{accessory.user_phone}}</p>
                              <p>{{accessory.user_email}}</p>
                           </div> 

                            <div class="col md-6 lg-4">
                              <h6>Posted on:</h6>
                              <p>{{$filters.formatDateTime(accessory.created_at)}}</p>
                              <h6>Last updated on:</h6>
                              <p>{{$filters.formatDateTime(accessory.updated_at)}}</p>
                           </div> 
                        </div >
                     </div>
                  </div>
               </div>

               <div class="card">
                  <div class="card-body">
                     <div class="row">
                        <h5>Images</h5>
                     </div><br>
                     
                     <div class="details">  
                        <div class="row">                          
                           <div class="col md-6 lg-3" v-for="img in accessory.images" :key="img.image">
                              <img :src="$image_url + img.image" alt="Image not found" style="width:100px">
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

            </div>
         </div>
      </div>
  </div>
</template>
<script>
export default {
   name:'AccessoryDetails',
   data() {
      return {
         accessory: {},         
         
         accessory_status: {
            id: "",
            status: ""
         },  

         marker: { position: { lat: 10, lng: 10 } },
         center: { lat: 10, lng: 10 },

         mapOptions: {
            disableDefaultUI: true,
         },          
         
         token: '',
         errors: {}
      };
   },
   mounted () {
      
   },

   created() {
      this.fetchAccessory();
   },

   methods: {
      
      fetchAccessory() {
          let url = '/api/admin/accessories/show?accessory_id=' + this.$route.params.id ;
            
         this.getToken();
         this.$axios
            .get(url, {headers: {Authorization: 'Bearer ' + this.token,}})
            .then(res => {
               var responseData = res.data.data;               
               this.accessory = responseData; 

               this.marker.position.lat = parseFloat(this.accessory.latitude);
               this.marker.position.lng = parseFloat(this.accessory.longitude);

               this.center.lat = parseFloat(this.accessory.latitude);
               this.center.lng = parseFloat(this.accessory.longitude);
               console.log(this.accessory);             
            })
            .catch(err => console.log(err));
      },   
      
      getMapUrl() {
            return `https://maps.google.com/maps?q=${this.center.lat},${this.center.lng}&z=15&output=embed`;
      },

      getToken() {
         if (localStorage.getItem('slo_admin')) {
            var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
            if(slo_admin.token) {
               this.token = slo_admin.token;
               this.user = slo_admin;

            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "Login" });
            }

         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "Login" });
         }
      },


      
   }   
}
</script>